//Types
export const Types = {
  GENERAL_STATISTICS: "GENERAL_STATISTICS",
  SET_LOADING: "SET_LOADING_STATISTICS",
  SET_LOADING_FILTERS: "SET_LOADING_FILTERS",
  SET_LOADING_TOTAL_REQUISITIONS: "SET_LOADING_TOTAL_REQUISITIONS",
  COLLECTION_STATISTICS: "COLLECTION_STATISTICS",
  COLLECTION_MONGO_STATISTICS: "COLLECTION_MONGO_STATISTICS",
  COLLECTION_CASSANDRA_STATISTICS: "COLLECTION_CASSANDRA_STATISTICS",
  COLLECTION_HADOOP_STATISTICS: "COLLECTION_HADOOP_STATISTICS",
  INJESTOR_STATISTICS: "INJESTOR_STATISTICS",
  STORAGE_STATISTICS: "STORAGE_STATISTICS",
  STORAGE_STATISTICS_FILTERS: "STORAGE_STATISTICS_FILTERS",
  APP_LAYER_STATISTICS: "APP_LAYER_STATISTICS",
  APP_LAYER_STATISTICS_FILTERS: "APP_LAYER_STATISTICS_FILTERS",
  SERVICE_LAYER_STATISTICS_USER: "SERVICE_LAYER_STATISTICS_USER",
  SERVICE_LAYER_STATISTICS_SYSTEM: "SERVICE_LAYER_STATISTICS_SYSTEM",
  SERVICE_LAYER_STATISTICS_COLLECTION: "SERVICE_LAYER_STATISTICS_COLLECTION",
};

//Reducer
const initialState = {
  generalStatistics: null,
  loading: false,
  loadingFilters: false,
  loadingTotalRequisitions: false,
  collectionStatistics: null,
  collectionMongoStatistics: null,
  collectionCassandraStatistics: null,
  collectionHadoopStatistics: null,
  injestorStatistics: null,
  storageStatistics: null,
  storageStatisticsfilters: null,
  appLayerStatistics: null,
  appLayerStatisticsFilters: null,
  serviceLayerStatisticsUser: null,
  serviceLayerStatisticsSystem: null,
  serviceLayerStatisticsCollection: null,
};

const Statistics = (state = initialState, action) => {
  switch (action.type) {
    case Types.GENERAL_STATISTICS:
      return {
        ...state,
        generalStatistics: action.payload,
        loading: false,
      };
    case Types.COLLECTION_MONGO_STATISTICS:
      return {
        ...state,
        collectionMongoStatistics: action.payload,
        loading: false,
      };
    case Types.COLLECTION_CASSANDRA_STATISTICS:
      return {
        ...state,
        collectionCassandraStatistics: action.payload,
        loading: false,
      };
    case Types.COLLECTION_HADOOP_STATISTICS:
      return {
        ...state,
        collectionHadoopStatistics: action.payload,
        loading: false,
      };
    case Types.COLLECTION_STATISTICS:
      return {
        ...state,
        collectionStatistics: action.payload,
        loading: false,
      };
    case Types.INJESTOR_STATISTICS:
      return {
        ...state,
        injestorStatistics: action.payload,
        loading: false,
      };
    case Types.STORAGE_STATISTICS:
      return {
        ...state,
        storageStatistics: action.payload,
        loading: false,
      };
    case Types.STORAGE_STATISTICS_FILTERS:
      return {
        ...state,
        storageStatisticsFilters: action.payload,
        loadingFilters: false,
      };
    case Types.APP_LAYER_STATISTICS:
      return {
        ...state,
        appLayerStatistics: action.payload,
        loading: false,
        loadingTotalRequisitions: false
      }
    case Types.APP_LAYER_STATISTICS_FILTERS:
        return {
          ...state,
          appLayerStatisticsFilters: action.payload,
          loadingFilters: false,
        }
    case Types.SERVICE_LAYER_STATISTICS_USER:
      return {
        ...state,
        serviceLayerStatisticsUser: action.payload,
        loading: false,
      };
    case Types.SERVICE_LAYER_STATISTICS_SYSTEM:
      return {
        ...state,
        serviceLayerStatisticsSystem: action.payload,
        loading: false,
      };
    case Types.SERVICE_LAYER_STATISTICS_COLLECTION:
      return {
        ...state,
        serviceLayerStatisticsCollection: action.payload,
        loading: false,
      };
    case Types.SET_LOADING:
      return {
        ...state,
        loading: true
      }
    case Types.SET_LOADING_TOTAL_REQUISITIONS:
        return {
          ...state,
          loadingTotalRequisitions: true
       }

    default:
      return state;
  }
};

export default Statistics;
